import { useQuery } from '@apollo/client';
import {
  ContextualMenu,
  IconButton,
  Modal,
  Spinner,
  useTheme,
} from '@fluentui/react';
import { TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes } from 'common/trainingSystem/__generated__/TrainingFolders';
import React from 'react';
import TRAINING_FILE_DATA from '../TrainingFile.graphql';
import {
  TrainingFile,
  TrainingFileVariables,
} from '../__generated__/TrainingFile';
import { useStyles } from './index.styles';

export type HelpContentViewModalProps = {
  selectedFile: TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const HelpContentViewModal: React.FC<HelpContentViewModalProps> = ({
  selectedFile,
  setShowModal,
}) => {
  const styles = useStyles();
  const theme = useTheme();
  const iconButtonStyles = {
    root: {
      color: theme.palette.neutralSecondaryAlt,
      marginLeft: 'auto',
      marginTop: '4px',
      marginRight: '2px',
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };

  const { data: trainingFileData, loading: trainingFileDataLoading } = useQuery<
    TrainingFile,
    TrainingFileVariables
  >(TRAINING_FILE_DATA, {
    variables: {
      id: selectedFile.id,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
  });
  const isPDF =
    trainingFileData?.trainingFile?.sharedDocumentFile?.iconType === 'PDF';
  return (
    <Modal
      isOpen
      onDismiss={() => setShowModal(false)}
      isModeless
      forceFocusInsideTrap
      dragOptions={{
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
        dragHandleSelector: '.ms-Modal-scrollableContent > div:first-child',
      }}
      containerClassName={styles.container}
      scrollableContentClassName={styles.scrollableContent}
    >
      <div className={styles.header}>
        <span className={styles.title}>
          Help Tutorials - {selectedFile.name}
        </span>
        <IconButton
          iconProps={{ iconName: 'Cancel' }}
          styles={iconButtonStyles}
          onClick={() => setShowModal(false)}
        />
      </div>

      <div className={styles.content}>
        {trainingFileDataLoading ? (
          <Spinner label="Loading..." labelPosition="right" />
        ) : isPDF ? (
          <object
            data={`${trainingFileData?.trainingFile?.sharedDocumentFile?._downloadLink}#viewrect=left,top,wd,ht`}
            className={trainingFileDataLoading ? styles.hidden : styles.viewer}
            aria-label={'pdf'}
          ></object>
        ) : (
          <video
            autoPlay
            controls
            className={trainingFileDataLoading ? styles.hidden : styles.viewer}
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
          >
            <source
              src={
                trainingFileData?.trainingFile?.sharedDocumentFile
                  ?._downloadLink
              }
              type="video/mp4"
            />
          </video>
        )}
      </div>
    </Modal>
  );
};
